import * as z from 'zod';

export const GetOrdersSettingsRequest = z.object({});
export const GetOrdersSettingsResponse = z.object({
  ordersSettings: z
    .object({
      inventoryUpdateTrigger: z
        .enum(['ON_ORDER_PAID', 'ON_ORDER_PLACED'])
        .describe(
          'Defines when to update the store inventory.\nDefault: `ON_ORDER_PLACED`'
        )
        .optional(),
      createInvoice: z
        .boolean()
        .describe(
          "Whether to automatically create invoices for every new order paid online.\n<br>\nDefault: `false`\n<br>\n**Note**: The issued invoice for an order is not a tax invoice and doesn't reflect refunds. You are responsible for ensuring that invoices you issue conform to any relevant legal requirements."
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the orders settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the orders settings were updated.')
        .optional()
        .nullable(),
    })
    .describe('Orders settings.')
    .optional(),
});
export const UpdateOrdersSettingsRequest = z.object({
  ordersSettings: z
    .object({
      inventoryUpdateTrigger: z
        .enum(['ON_ORDER_PAID', 'ON_ORDER_PLACED'])
        .optional(),
      createInvoice: z
        .boolean()
        .describe(
          "Whether to automatically create invoices for every new order paid online.\n<br>\nDefault: `false`\n<br>\n**Note**: The issued invoice for an order is not a tax invoice and doesn't reflect refunds. You are responsible for ensuring that invoices you issue conform to any relevant legal requirements."
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the orders settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the orders settings were updated.')
        .optional()
        .nullable(),
    })
    .describe('Orders settings to update.'),
});
export const UpdateOrdersSettingsResponse = z.object({
  ordersSettings: z
    .object({
      inventoryUpdateTrigger: z
        .enum(['ON_ORDER_PAID', 'ON_ORDER_PLACED'])
        .describe(
          'Defines when to update the store inventory.\nDefault: `ON_ORDER_PLACED`'
        )
        .optional(),
      createInvoice: z
        .boolean()
        .describe(
          "Whether to automatically create invoices for every new order paid online.\n<br>\nDefault: `false`\n<br>\n**Note**: The issued invoice for an order is not a tax invoice and doesn't reflect refunds. You are responsible for ensuring that invoices you issue conform to any relevant legal requirements."
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the orders settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the orders settings were updated.')
        .optional()
        .nullable(),
    })
    .describe('The updated orders settings.')
    .optional(),
});
